<template>
  <div class="webchat-inner-container">
    <template v-if="initialDataRetrieved">
      <ChatOnline
        v-if="showChat === true"
        v-bind:loading="loading"
        v-bind:agentsIdle="agentsIdle"
      />
      <ChatOffline
        :webchatAvailable="webchatAvailable"
        :closed="closed"
        :insideHours="insideHours"
        v-else
      />
    </template>
    <template v-else> Loading... </template>
  </div>
</template>

<script>
const axios = require("axios");
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import ChatOnline from "./components/ChatOnline";
import ChatOffline from "./components/ChatOffline";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);

export default {
  components: {
    ChatOnline,
    ChatOffline,
  },
  data: () => ({
    loading: true,
    showChat: false,
    agentsIdle: false,
    agentsInteracting: false,
    insideHours: null,
    day: null,
    webchatAvailable: true,
    initialDataRetrieved: false,
  }),
  methods: {
    toggleOnline: function() {
      this.showChat = !this.showChat;
    },
  },
  mounted: async function() {
    this.$on("callbackClicked", function() {
      this.showChat = false;
    });

    let now = dayjs().tz("Australia/Brisbane");
    let hour = now.hour();
    let day = now.day();
    this.insideHours = hour >= 9 && hour < 17 && day >= 1 && day <= 5;


    let d1 = dayjs().isBetween(
        "2023-01-02T00:00:00.000+1000",
        "2023-01-02T23:59:59.000+1000"
    )
    let d2 = dayjs().isBetween(
        "2023-01-26T00:00:00.000+1000",
        "2023-01-26T23:59:59.000+1000"
    )
    let d3 = dayjs().isBetween(
        "2023-04-07T00:00:00.000+1000",
        "2023-04-07T23:59:59.000+1000"
    )
    let d4 = dayjs().isBetween(
        "2023-04-10T00:00:00.000+1000",
        "2023-04-10T23:59:59.000+1000"
    )
    let d5 = dayjs().isBetween(
        "2023-04-25T00:00:00.000+1000",
        "2023-04-25T23:59:59.000+1000"
    )
    let d6 = dayjs().isBetween(
        "2023-05-01T00:00:00.000+1000",
        "2023-05-01T23:59:59.000+1000"
    )
    let d7 = dayjs().isBetween(
        "2023-10-02T00:00:00.000+1000",
        "2023-10-02T23:59:59.000+1000"
    )
    let d8 = dayjs().isBetween(
        "2023-12-26T00:00:00.000+1000",
        "2023-12-26T23:59:59.000+1000"
    )


    let d9 = dayjs().isBetween(
        "2022-12-24T00:00:00.000+1000",
        "2022-12-24T23:59:59.000+1000"
    )
    let d10 = dayjs().isBetween(
        "2022-12-25T00:00:00.000+1000",
        "2022-12-25T23:59:59.000+1000"
    )
    let d11 = dayjs().isBetween(
        "2022-12-26T00:00:00.000+1000",
        "2022-12-26T23:59:59.000+1000"
    )

    // https://ccq.zendesk.com/agent/tickets/57758
    this.closed = [d1,d2,d3,d4,d5,d6,d7,d8,d9,d10,d11].some((c) => c);

    if (window.availableToday === false) {
      this.showChat = false;
      this.webchatAvailable = false;
      this.initialDataRetrieved = true;
      return;
    } else if (window.availableToday && this.insideHours && !this.closed) {
      axios
        .get(
          "https://prod-30.australiaeast.logic.azure.com:443/workflows/0fbd9f69907a42abbc292803e3acfaaa/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=YOh-WJaGQKBrp2VwD1IFEIDbmyk5qHWzcL265t2Mnu8"
        )
        .then((res) => {
          let results = res.data.results.find(
            (result) => !("mediaType" in result.group)
          );
          let agents = results.data;
          this.agentsIdle = agents.find(
            (status) =>
              status.metric === "oUserRoutingStatuses" &&
              status.qualifier === "IDLE"
          )
            ? agents.find(
                (status) =>
                  status.metric === "oUserRoutingStatuses" &&
                  status.qualifier === "IDLE"
              ).stats.count > 0
            : false;
          this.agentsInteracting = agents.find(
            (status) =>
              status.metric === "oUserRoutingStatuses" &&
              status.qualifier === "INTERACTING"
          )
            ? agents.find(
                (status) =>
                  status.metric === "oUserRoutingStatuses" &&
                  status.qualifier === "INTERACTING"
              ).stats.count > 0
            : false;
          this.showChat = this.agentsIdle || this.agentsInteracting;
        })
        .catch((err) => {
          console.error(err);
          this.showChat = false;
        })
        .finally(() => {
          this.loading = false;
          this.initialDataRetrieved = true;
        });
    } else {
      this.showChat = false;
      this.initialDataRetrieved = true;
    }
  },
};
</script>

<style>
html {
  font-size: 62.5% !important;
}

.webchat-inner-container {
  color: black;
}

.webchat-inner-container button {
  background: #009bdc !important;
  font-weight: 700 !important;
  box-shadow: 0px 1px 10px #00000030;
  padding: 5px 30px;
  border-radius: 100px;
}
.webchat-inner-container .debug-chat {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 20px;
  background: rgb(58, 58, 58);
  color: white !important;
  margin: 5px;
  box-shadow: 0px 0px 2px dimgrey;
  cursor: pointer;
  border-radius: 40px;
}
</style>
